import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import { Box, Stack } from "@mui/material";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormHelper } from "../../../../../helpers/formHelper";
import { Section } from "../../../../../shared/components/common/section";
import { SectionWithHeading } from "../../../../../shared/components/common/sectionWithHeading";
import { ButtonWrapper } from "../../../../../shared/components/formUtilities/useButton";
import { InputWrapper } from "../../../../../shared/components/formUtilities/useInput";
import { TextWrapper } from "../../../../../shared/components/formUtilities/useTextWrapper";
import { InvestorService } from "../../../investorService";
import { APIKeyDialog } from "./apiKeyDialog";
import { useInvestorDetails } from '../../../../../context/investorDetailContext';
import { Toaster } from '../../../../../shared/components/common/toaster';

export const ExternalIntegration = () => {
  const investorService = new InvestorService();
  const [isEditInfo, setIsEditInfo] = useState(false);
  const [loadingApikey, setLoadingApikey] = useState(false);
  const [apiKey, setApikey] = useState(null);
  const { investorDetails, setInvestorDetails } = useInvestorDetails();
  const { t } = useTranslation();

  const form = useFormik({
    initialValues: {
      webhook: ""
    },
    onSubmit: () => {
      onSaveWebhook();
    },
    ...FormHelper.formikProps()
  });

  useEffect(() => {
    if (investorDetails && investorDetails?.integrationWebHookUrl) {
      form.setFieldValue("webhook", investorDetails?.integrationWebHookUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investorDetails]);

  const onEdit = (e) => {
    e.preventDefault();
    if (isEditInfo) {
      FormHelper.validateForm(form);
    } else {
      setIsEditInfo(!isEditInfo);
    }
  };

  const onGenerateAPIKey = () => {
    setLoadingApikey(true);
    investorService.generateAPIKey().then(resp => {
      setApikey(resp.data);
    }).catch(err => {
    }).finally(err => {
      setLoadingApikey(false);
    });
  };

  const onSaveWebhook = () => {
    investorService.saveWebhook(form.values).then(resp => {
      setIsEditInfo(!isEditInfo);
      setInvestorDetails({ ...investorDetails, integrationWebHookUrl: form.values.webhook });
      Toaster({ msg: "Request successfully completed.", isError: false });
    }).catch(err => { }).finally(err => { });
  };

  return <Box>
    <SectionWithHeading
      isEditButton={true}
      onEditInfo={(e) => {
        onEdit(e);
      }}
      isEditToggle={isEditInfo}
      heading={
        <Box className="flex items-center">
          <IntegrationInstructionsIcon
            className="!text-[26px]"
            color="primary"></IntegrationInstructionsIcon>
          <span className="mx-2">{t('integration')}</span>
        </Box>
      }
      children={
        <FormikProvider value={form}>
          <Box className='flex justify-center'>
            <Section classList='!w-full !p-0' isShadow={false}
              children={
                <Stack className="text-start" gap={3}>
                  <Box>
                    <TextWrapper classList="!text-lg !font-bold" text="Webhook" />
                    <Box className='caption !text-[13px]'>{t('webhookInfoText')}</Box>
                    <FormikProvider value={form}>
                      <fieldset disabled={!isEditInfo}>
                        <Box className='grid grid-cols-1 md:grid-cols-1 gap-4 mt-3'>
                          <InputWrapper name={'webhook'} key={'webhook'} label={t('webhookUrl')} />
                        </Box>
                      </fieldset>
                    </FormikProvider>
                  </Box>
                  <Box>
                    <TextWrapper classList="!text-lg !font-bold" text="API key" />
                    <Box className='caption !text-[13px]'>{t('apiKeyInfoText')}</Box>
                    <Box className='mt-3'>
                      <ButtonWrapper loading={loadingApikey} onClick={() => { onGenerateAPIKey(); }} label={t('generateAPIKey')} />
                    </Box>
                  </Box>
                </Stack>
              }></Section>
          </Box>
        </FormikProvider>
      }></SectionWithHeading>
    {apiKey ? <APIKeyDialog apiKey={apiKey} state={!!apiKey} onClose={() => {
      setApikey(null);
    }} /> : null}
  </Box>;
};